// 3D VOLUMES INSIDE LEVELS, AREAS & SYSTEMS (owner 2026-11-01: off the Coordination tab strip,
// into this page). ?view=volumes picks the view. Kept out of CoordinationAreasPage on purpose:
// one more branch in that 1,900-line component tipped the hooks lint rule's path count over and
// it then reported every hook as conditional - a failed production build (2026-11-02).
import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Segmented } from "antd";
import CoordinationBreadcrumbs from "components/Coordination/CoordinationBreadcrumbs";
import SignoffVolumesPage from "pages/SignoffVolumes/SignoffVolumesPage";
import { signoffPagesOn } from "pages/SignoffTimeline/signoffRelease";
import CoordinationAreasPage from "./CoordinationAreasPage";

export const viewOf = (search) => (signoffPagesOn() && new URLSearchParams(search || "").get("view") === "volumes" ? "volumes" : "levels");

/** The Levels & areas / 3D volumes switch at the top of the page. */
export default function AreasViewSwitch() {
  const history = useHistory();
  const location = useLocation();
  if (!signoffPagesOn()) return null;
  const onChange = (v) => {
    const q = new URLSearchParams(location.search);
    if (v === "volumes") q.set("view", "volumes"); else q.delete("view");
    const qs = q.toString();
    history.push(`${location.pathname}${qs ? `?${qs}` : ""}`);
  };
  return (
    <Segmented className="mb-3" value={viewOf(location.search)} onChange={onChange} data-testid="areas-view-switch"
               options={[{ value: "levels", label: "Levels & areas" }, { value: "volumes", label: "3D volumes" }]} />
  );
}

/** The 3D volumes view of the page: the same frame, the switch, and the volumes for the project. */
export function AreasVolumesView() {
  const { projectId } = useParams();
  return (
    <div className="personal-area">
      <div className="content-bg p-2">
        <div className="container-fluid px-3">
          <CoordinationBreadcrumbs current="Levels, Areas & Systems" />
          <h4 className="mb-2">Levels, Areas &amp; Systems</h4>
          <AreasViewSwitch />
          {/* no project in the address yet: the volumes page picks one (the remembered one) and puts it there */}
          <SignoffVolumesPage embedded={!!projectId} projectId={projectId || ""} />
        </div>
      </div>
    </div>
  );
}

/** The route: /areas[/:projectId][?view=volumes]. */
export function AreasRoute() {
  const location = useLocation();
  return viewOf(location.search) === "volumes" ? <AreasVolumesView /> : <CoordinationAreasPage />;
}
